// services/rsvpService.ts
// Servicio para enviar confirmaciones a Google Sheets

export interface RSVPGuestData {
  name: string;
  confirmed: boolean;
  isChild: boolean;
}

export interface RSVPSubmission {
  familyName?: string;
  guests?: RSVPGuestData[];
  name?: string;
  decline?: boolean;
}

class RSVPService {
  private scriptURL: string;

  constructor() {
    // Obtener la URL del script desde las variables de entorno
    this.scriptURL = process.env.REACT_APP_GOOGLE_SCRIPT_URL || '';
    
    if (!this.scriptURL) {
      console.error('⚠️ REACT_APP_GOOGLE_SCRIPT_URL no está configurada en .env');
    }
  }

  /**
   * Enviar confirmación de familia con todos los invitados y su estado
   */
  async submitFamilyRSVP(
    familyName: string, 
    guests: Array<{ name: string; isChild: boolean; confirmed: boolean }>
  ): Promise<boolean> {
    try {
      const guestData: RSVPGuestData[] = guests.map(guest => ({
        name: guest.name,
        confirmed: guest.confirmed,
        isChild: guest.isChild
      }));

      const payload: RSVPSubmission = {
        familyName,
        guests: guestData
      };

await fetch(this.scriptURL, {
          method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      });

      console.log(`✅ Confirmación de familia ${familyName} enviada a Google Sheets`);
      return true;

    } catch (error) {
      console.error('❌ Error al enviar confirmación de familia:', error);
      return false;
    }
  }

  /**
   * Enviar confirmación genérica (sin familia específica)
   */
  async submitGenericRSVP(name: string): Promise<boolean> {
    try {
      const payload: RSVPSubmission = {
        name
      };

await fetch(this.scriptURL, {
          method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      });

      console.log('✅ Confirmación genérica enviada a Google Sheets');
      return true;

    } catch (error) {
      console.error('❌ Error al enviar confirmación genérica:', error);
      return false;
    }
  }

  /**
   * Enviar cuando la familia NO puede asistir
   */
  async submitDecline(familyName: string, declinedBy: string): Promise<boolean> {
    try {
      const payload: RSVPSubmission = {
        familyName,
        name: declinedBy, // Usamos el nombre de la persona que declina
        decline: true,
        guests: [{
          name: declinedBy,
          confirmed: false,
          isChild: false
        }]
      };

await fetch(this.scriptURL, {
          method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      });

      console.log('✅ Declinación enviada a Google Sheets con valor 0 para:', declinedBy);
      return true;

    } catch (error) {
      console.error('❌ Error al enviar declinación:', error);
      return false;
    }
  }

  /**
   * Verificar que el servicio está configurado
   */
  isConfigured(): boolean {
    return this.scriptURL !== '';
  }
}

// Exportar instancia única del servicio
export const rsvpService = new RSVPService();